import { AccessorialCode, ShippingPointDetails } from '@rygen/rygen-ui/model';
import { fromJSDate } from '@rygen/rygen-ui/util';

import { EmbeddableLocation } from '../EmbeddableLocation';
import { ShipmentStopType } from '../shipment/ShipmentStopType';
import { ShippingPoint } from '../ShippingPoint';

const TYPE = 'QuickQuote';

export class QuickQuoteShippingPoint implements ShippingPoint {
  id?: number;
  stopType: ShipmentStopType.PICKUP | ShipmentStopType.DROP_OFF;
  location: EmbeddableLocation = new EmbeddableLocation();
  shippingPointDetails: ShippingPointDetails = new ShippingPointDetails();
  shipDate?: Date;
  requestedAccessorials: AccessorialCode[] = [];

  constructor(opts?: Partial<QuickQuoteShippingPoint>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (typeof opts?.stopType === 'string') {
      this.stopType = ShipmentStopType[opts.stopType];
    } else {
      this.stopType = opts?.stopType ?? ShipmentStopType.PICKUP;
    }
    if (opts?.location != null) {
      this.location = new EmbeddableLocation(opts.location);
    }
    if (opts?.shippingPointDetails != null) {
      this.shippingPointDetails = new ShippingPointDetails(
        opts.shippingPointDetails,
      );
    }
    if (opts?.shipDate != null) {
      this.shipDate = new Date(opts.shipDate);
    }
    if (opts?.requestedAccessorials != null) {
      this.requestedAccessorials = opts.requestedAccessorials.map(
        (val) => new AccessorialCode(val),
      );
    }
  }

  static isQuickQuoteShippingPoint(
    location: ShippingPoint,
  ): location is QuickQuoteShippingPoint {
    return location.type === TYPE;
  }

  get requestedAppointmentEarliest() {
    return fromJSDate(this.shipDate);
  }

  get type() {
    return TYPE;
  }

  get isInProgress() {
    return false;
  }

  get isPickup() {
    return this.stopType === ShipmentStopType.PICKUP;
  }

  get isDropOff() {
    return this.stopType === ShipmentStopType.DROP_OFF;
  }

  get sequenceNumber() {
    return this.stopType === ShipmentStopType.PICKUP ? 1 : 2;
  }

  get stopLabel(): string {
    return [this.location.locationName, this.location.city, this.location.state]
      .filter((x) => !!x?.trim())
      .join(', ');
  }

  isResolved(_requireBothDate: boolean = false) {
    return false;
  }
}
